import UserCardInfoBlock from './UserCardInfoBlock';

export default UserCardInfoBlock;
